import { fetchJsonResponse } from '@/ai/api'
import { buildReadModelFromWorkflowPrompt } from '@/ai/prompts'

export const generateReadModelFromWorkflow = async ({
  eventId,
  workflow,
  cardTypes,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildReadModelFromWorkflowPrompt({
    eventId,
    workflow,
    cardTypes
  })

  const response = await fetchJsonResponse({
    messages,
    aiVersion: workflow.aiVersion,
    signal: abortController?.signal
  })

  return response || null
}
